import React, { useState } from "react";
import "./styles/Contact.css";
import iconstar1 from './images/star01.png';
import iconstar2 from './images/star01.png';
import priceGE from './images/light GE.png'

const ContactMe = () => {
  const [result, setResult] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");

    const formData = new FormData(event.target);
    formData.append("access_key", "2018513c-dcb0-45b2-b971-d1ad82a06d31");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });

      const data = await response.json();
      
      if (data.success) {
        setResult("Form Submitted Successfully");
        event.target.reset(); // Reset form fields
      } else {
        setResult(data.message || "Form submission failed");
        console.error("Submission Error:", data);
      }
    } catch (error) {
      setResult("Network error, please try again later.");
      console.error("Network Error:", error);
    }
  };

  return (
    <div className="contact-component">
      <div className="contact-container">
        <div className="form-section">
          <h2>Need a Sound <span>Partner?</span></h2>
          <h2 className="work">Let's Work <span>Together!</span></h2>
          <form className="contact-form" onSubmit={handleSubmit}>
            <label htmlFor="name" className="label1">Name</label>
            <input type="text" name="name" required />

            <div className="input-cell">
              <div className="email">
                <label htmlFor="email" >E mail</label>
                <input type="email" name="email" required />
              </div>
              <div className="phone">
                <label htmlFor="phone">Phone #</label>
                <input type="tel" name="phone" required />
              </div>
            </div>

            <label htmlFor="message" className="label1">Message</label>
            <textarea name="message" rows="5" required></textarea>
            
            <div className="submit-btn">
              <button type="submit">Submit</button>
            </div>
          </form>
          
          <span>{result}</span> {/* Display submission result */}
          
          <div className="below-msg">
            <p className="or">Or</p>
            <p className="email-contact">
              Email: <a href="mailto:contact@audioeditingguy.com">contact@audioeditingguy.com</a>
            </p>
            <p className="footer-text">Looking forward to hearing from you..!!</p>
          </div>
        </div>
        
        <div className="description-section">
          <img src={iconstar1} alt="icon" />
          <img src={iconstar2} alt="icon" />
          <div className="contact-msg">
            <p>
              As a dedicated professional in audiobook and podcast editing, I understand the critical importance of capturing the essence of your content right from the start. Whether it’s ensuring clarity and coherence or refining the audio for your audience, I am committed to excellence in every project.
              <br/><br/>
              Before committing to my services, I'm delighted to offer a complimentary sample editing. This allows you to gauge my suitability for the role with confidence.
              <br/><br/>
              My standard turnaround time is within 24 hours, but I’m flexible to accommodate your project’s timeline, ensuring a swift delivery.
              <br/><br/>
              In essence, I adapt to your unique requirements. I eagerly anticipate the opportunity to collaborate with you and fulfill your editing needs promptly and effectively, delivering results in your preferred formats, be it mp3 or wav.
            </p>
          </div>
        </div>
      </div>
      <div className="img-bg"><img src={priceGE} alt="" /></div>

    </div>
  );
};

export default ContactMe;
